import { Box, Flex, Text, chakra } from '@chakra-ui/react';

interface PublicToggleProps {
  isPublic: boolean;
  onToggle: (isPublic: boolean) => void;
  disabled?: boolean;
  /** Legend label (default: Public Event) */
  title?: string;
  publicLabel?: string;
  privateLabel?: string;
  helperWhenPublic?: string;
  helperWhenPrivate?: string;
}

export function PublicToggle({
  isPublic,
  onToggle,
  disabled = false,
  title = 'Public Event',
  publicLabel = 'Public',
  privateLabel = 'Private',
  helperWhenPublic = 'Everyone can see this event',
  helperWhenPrivate = 'Only members can see this event',
}: PublicToggleProps) {
  return (
    <Box mb={{ base: '4', md: '0' }}>
      <Box as="fieldset" border="0" p="0" m="0">
        <Text as="legend" display="block" mb="2" fontSize={{ base: 'sm', md: 'md' }} fontWeight="medium" color="volyx.text">
          {title}
        </Text>
        <Flex gap="2" mb="2" role="group">
          <chakra.button
            flex="1"
            h="14"
            borderRadius="xl"
            fontWeight="semibold"
            transition="all 0.2s"
            border="0"
            outline="none"
            _focus={{ outline: 'none' }}
            bg={isPublic ? 'volyx.action' : 'volyx.lightGray'}
            color={isPublic ? 'white' : 'volyx.text'}
            boxShadow={isPublic ? '0 4px 12px rgba(0,0,0,0.08)' : '0 1px 3px rgba(0,0,0,0.08)'}
            _hover={
              isPublic
                ? { bg: 'rgba(0,122,255,0.9)' }
                : { boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }
            }
            _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}
            cursor="pointer"
            onClick={() => onToggle(true)}
            disabled={disabled}
            aria-pressed={isPublic}
          >
            {publicLabel}
          </chakra.button>
          <chakra.button
            flex="1"
            h="14"
            borderRadius="xl"
            fontWeight="semibold"
            transition="all 0.2s"
            border="0"
            outline="none"
            _focus={{ outline: 'none' }}
            bg={!isPublic ? 'volyx.action' : 'volyx.lightGray'}
            color={!isPublic ? 'white' : 'volyx.text'}
            boxShadow={!isPublic ? '0 4px 12px rgba(0,0,0,0.08)' : '0 1px 3px rgba(0,0,0,0.08)'}
            _hover={
              !isPublic
                ? { bg: 'rgba(0,122,255,0.9)' }
                : { boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }
            }
            _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}
            cursor="pointer"
            onClick={() => onToggle(false)}
            disabled={disabled}
            aria-pressed={!isPublic}
          >
            {privateLabel}
          </chakra.button>
        </Flex>
        <Text fontSize="xs" color="volyx.textSecondary">
          {isPublic ? helperWhenPublic : helperWhenPrivate}
        </Text>
      </Box>
    </Box>
  );
}
